import React from "react";
import { Form, Input, Row, Col } from "antd";
import { useTranslation } from "react-i18next";


const TabletForm = ({ form }) => {
  const { t } = useTranslation();

  return (
    <Form form={form} layout="vertical">
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            name="tablet_id"
            label={t("tableHeader.tabletId")}
            rules={[
              {
                required: true,
                message: t("validation.tabletIdRequired"),
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            name="name"
            label={t("tableHeader.name")}
            rules={[
              {
                required: true,
                message: t("validation.tabletNameRequired"),
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default TabletForm;
